import { Close } from "@/components/Icons/utility/Close.tsx";
import { useGetCancelationPolicyTranslated } from "@/helpers/translation/useGetCancelationPolicyTranslated.ts";
import { CancelationPolicy } from "@/helpers/types/types.ts";
import { useModalStore } from "@/stores/ModalStore/useModalStore.ts";
import "./RPCancelationPolicyModalDetailed.scss";

export const RPCancelationPolicyModalDetailed = () => {
  const editObj = useModalStore<CancelationPolicy>((s) => s.editObj as CancelationPolicy);
  const closeModal = useModalStore((s) => s.closeModal);
  const { name, description } = useGetCancelationPolicyTranslated(editObj);

  return (
    <div className="cancelation-policy-modal">
      <div className="cancelation-policy-content">
        <div className="cancelation-policy-content__close">
          <button
            className="cancelation-policy-content__closeBtn"
            onClick={() => closeModal()}
            aria-label="Close modal"
          >
            <Close />
          </button>
        </div>

        <div className="policy-body">
          <div className="policy-name">
            <div className="policy-value">{name}</div>
          </div>

          <div className="policy-description">
            <div className="policy-value--description" dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </div>
      </div>
    </div>
  );
};
